export default __webpack_public_path__ + "img/qeKHJTZa.b1d0eaf7.svg";